import { MonthlyProductionCard } from "./MonthlyProductionCard";
export default MonthlyProductionCard;
